export default {
  newsletter: {
    success: {
      sk: '👌 E-mail odoslaný',
      en: '👌 E-mail was sent',
    },
    subscribe: {
      sk: 'Odoberať',
      en: 'Subscribe',
    },
    requiredMail: {
      sk: '👇 E-mailová adresa je povinná',
      en: '👇 E-mail address is required',
    },
    notValidMail: {
      sk: '👇 Nesprávne vyplnená e-mailová adresa',
      en: '👇 The e-mail address is not valid',
    },
    confirmMessage: {
      sk:
        '👌 Prosím, potvrďte odber kliknutím na odkaz, ktorý sme Vám práve zaslali',
      en:
        '👌 Please confirm your subscription by clicking the link we have sent you',
    },
  },
};



// WEBPACK FOOTER //
// ./src/data/newsletter.js